<ng-container *ngIf="filteredAlerts.length; else noItems">
    <mat-list>
        <div class="list-header" *ngIf="!filterValue">File Alerts</div>
        <app-patient-list-item *ngFor="let patient of filteredAlerts | slice:0:shown" [patient]="patient"></app-patient-list-item>
        <div *ngIf="shown < filteredAlerts.length" (appRenderMore)="shown = shown + renderBatch"></div>
    </mat-list>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noItems>
    <p class="no-records-message">No file alerts found.</p>
</ng-template>